<template>
  <div class="fit bg- flex flex-center overflow-hidden flex-no-wrap">
    <div class="flex-1 h-full overflow-hidden">
      <div class="fit flex flex-col gap-4 p-4" style="min-width: 600px">
        <NotificationWidget />
        <!-- <span>{{ store.selected }}</span>
        <span @click="store.selected = 1">test</span> -->
        <MaintenanceList
          @selected="
            (v) => {
              store.selected = v.id;
            }
          "
          :selected="store.selected"
        />
      </div>
    </div>
    <DetailsPageComp :style="detailsPage" :id="store.selected">
      <div
        v-if="!$route.query.asset"
        @click="detailsPanel = !detailsPanel"
        :aria-label="detailsPanel ? 'Collapse Panel' : 'Expand Panel'"
        class="absolute panel-button flex flex-center"
        style="box-shadow: -2px 2px 5px rgba(0, 0, 0, 0.2)"
      >
        <img
          :style="{ transform: `scale(${detailsPanel ? -1 : 1})` }"
          src="//maps.gstatic.com/tactile/pane/arrow_left_1x.png"
        />
        <q-tooltip content-class="bg-black">
          {{ detailsPanel ? 'Collapse Panel' : 'Expand Panel' }}
        </q-tooltip>
      </div>
    </DetailsPageComp>
  </div>
</template>

<script setup>
import {
  onMounted,
  onUnmounted,
  ref,
  watch,
  computed,
  defineExpose,
  defineEmits,
  nextTick,
  onBeforeMount,
} from 'vue';
import { useElementSize, useStyleTag } from '@vueuse/core';
import { useRoute, useRouter } from 'vue-router/composables';
import { store } from './api/api';

import { customCss } from '@//views/experimental/table-view/quasar';
import NotificationWidget from './main/NotificationWidget.vue';
import MaintenanceList from './main/MaintenanceList.vue';
import DetailsPageComp from './details/DetailsPage.vue';

const { id, css, load, unload } = useStyleTag(customCss, { id: 'naruto' });
onUnmounted(() => {
  unload();
});

const route = useRoute();

const detailsPanel = ref(false);
watch(
  () => store.selected,
  () => {
    if (store.selected) {
      detailsPanel.value = true;
    }
  },
  { immediate: true },
);

const selectedDetails = ref(null);
watch(
  () => route.query.asset,
  async (v) => {
    selectedDetails.value = v;
    if (v) {
      store.selected = v;
    } else {
      await nextTick();
      await store.getMainPageDev();
    }
  },
  { immediate: true },
);

const detailsPage = computed(() => {
  if (selectedDetails.value) {
    return { width: '100%' };
  } else {
    if (detailsPanel.value) {
      return { width: '400px' };
    }
    return { width: 0 };
  }
});

onBeforeMount(() => {
  store.userInfo = JSON.parse(localStorage.getItem('userInfo'));
  store.unitSelection = JSON.parse(localStorage.getItem('unitSelection'));
});
onUnmounted(() => {
  store.userInfo = null;
  store.unitSelection = null;
  store.state = {};
  store.edited = false;
  store.fetching = false;
  store.list = null;
  store.selected = null;
  store.data = null;
});
</script>

<style>
.panel-button {
  transform: translate(-100%, -50%);
  top: 50%;
  white-space: normal;
  font: inherit;
  list-style: none;
  margin: 0;
  outline: 0;
  overflow: visible;
  padding: 0;
  vertical-align: baseline;
  color: inherit;
  border: 0;
  box-shadow:
    0 1px 2px rgba(60, 64, 67, 0.3),
    0 2px 6px 2px rgba(60, 64, 67, 0.15);
  width: 23px;
  height: 48px;
  cursor: pointer;
  border-left: 1px solid #dadce0;
  background: #fff 7px center/7px 10px no-repeat;
  background-color: #fff;
  border-radius: 8px 0 0 8px;
}
</style>
